import { api } from './api';

// Récupérer tous les articles d'inventaire du client connecté
export const getClientInventory = async () => {
  try {
    const response = await api.getClientInventory();
    return response.data || [];
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'inventaire:', error);
    throw error;
  }
};

// Récupérer un article spécifique par son ID
export const getInventoryItem = async (id) => {
  try {
    const response = await api.getInventoryItem(id);
    return response.data;
  } catch (error) {
    console.error(`Erreur lors de la récupération de l'article ${id}:`, error);
    throw error;
  }
};

// Créer un nouvel article d'inventaire
export const createInventoryItem = async (itemData) => {
  try {
    const response = await api.createInventoryItem(itemData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la création de l\'article:', error);
    throw error;
  }
};

// Mettre à jour un article existant
export const updateInventoryItem = async (id, itemData) => {
  try {
    const response = await api.updateInventoryItem(id, itemData);
    return response.data;
  } catch (error) {
    console.error(`Erreur lors de la mise à jour de l'article ${id}:`, error);
    throw error;
  }
};

// Supprimer un article
export const deleteInventoryItem = async (id) => {
  try {
    const response = await api.deleteInventoryItem(id);
    return response.success;
  } catch (error) {
    console.error(`Erreur lors de la suppression de l'article ${id}:`, error);
    throw error;
  }
};

// Obtenir les statistiques d'inventaire
export const getInventoryStats = async () => {
  try {
    const response = await api.getInventoryStats();
    return response.data || {
      totalItems: 0,
      itemsByCategory: {},
      mostCommonCategory: '',
      itemsNeedingAttention: 0,
      itemsInTransit: 0,
      itemsInStock: 0
    };
  } catch (error) {
    console.error('Erreur lors de la récupération des statistiques d\'inventaire:', error);
    // Retourner des valeurs par défaut en cas d'erreur
    return {
      totalItems: 0,
      itemsByCategory: {},
      mostCommonCategory: '',
      itemsNeedingAttention: 0,
      itemsInTransit: 0,
      itemsInStock: 0
    };
  }
};

// Rechercher dans l'inventaire
export const searchInventory = async (query) => {
  try {
    const response = await api.searchInventory(query);
    return response.data || [];
  } catch (error) {
    console.error('Erreur lors de la recherche dans l\'inventaire:', error);
    throw error;
  }
};
